(function () {
  "use strict";

  /* ============================================================
    ETH QUICK BUY — GLOBAL
    Cart state, stepper, toast, modal open/close,
    variant selection, add to cart, swipe, description fetch.
    Scoped per section via data-section-id.
  ============================================================ */

  var rootUrl = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : "/";

  // ── Cart state ──────────────────────────────────────────────
  window.ethCartState = window.ethCartState || {};

  // ── Per-variant write lock ──────────────────────────────────
  // Blocks a second cart write for the same variant while one is in flight,
  // preventing double-add (fast taps) and out-of-order quantity writes.
  var ethWriteLock = {};
  var ethLockTimers = {};
  function lockVariant(vid) {
    if (ethWriteLock[vid]) return false;
    ethWriteLock[vid] = true;
    clearTimeout(ethLockTimers[vid]);
    // Safety net: never leave a variant permanently locked if a request hangs.
    ethLockTimers[vid] = setTimeout(function () { delete ethWriteLock[vid]; delete ethLockTimers[vid]; }, 8000);
    return true;
  }
  function unlockVariant(vid) {
    clearTimeout(ethLockTimers[vid]);
    delete ethLockTimers[vid];
    delete ethWriteLock[vid];
  }

  function fetchCart(callback) {
    fetch(rootUrl + "cart.js", {
      method: "GET", credentials: "same-origin",
      headers: { "Accept": "application/json" }
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var state = {};
        (cart.items || []).forEach(function (item) {
          state[String(item.variant_id)] = (state[String(item.variant_id)] || 0) + item.quantity;
        });
        window.ethCartState = state;
        updateAllCartBadges(cart.item_count);
        document.dispatchEvent(new CustomEvent("cart:updated", { detail: { cart: cart } }));
        if (callback) callback(cart);
      })
      .catch(function () { if (callback) callback(null); });
  }

  function updateAllCartBadges(count) {
    document.querySelectorAll(".js-cart-count, [data-cart-count], .cart-count, .site-header__cart-count, .cart-count-bubble, #CartCount").forEach(function (el) {
      el.textContent = count;
      el.classList.remove("eth-badge-pulse"); void el.offsetWidth; el.classList.add("eth-badge-pulse");
      if (count > 0) el.classList.remove("hide");
    });
  }

  // ── Toast ────────────────────────────────────────────────────
  var toastEl = null, toastTimer = null;

  function ensureToast() {
    if (toastEl) return;
    toastEl = document.createElement("div");
    toastEl.id = "eth-toast";
    document.body.appendChild(toastEl);
  }

  function showToast(message) {
    ensureToast();
    clearTimeout(toastTimer);
    toastEl.textContent = message;
    toastEl.classList.remove("is-hiding");
    toastEl.classList.add("is-visible");
    toastTimer = setTimeout(function () {
      toastEl.classList.remove("is-visible");
      toastEl.classList.add("is-hiding");
      setTimeout(function () { toastEl.classList.remove("is-hiding"); }, 260);
    }, 2200);
  }

  // ── Grid stepper ─────────────────────────────────────────────
  var _gridObserver = null;

  function renderStepper(wrapper, variantId, qty) {
    wrapper.innerHTML = "";
    if (!qty || qty <= 0) {
      var btn = document.createElement("button");
      btn.type = "button"; btn.className = "eth-add-btn";
      btn.setAttribute("data-variant-id", variantId);
      btn.innerHTML = '<span class="eth-btn-label">+ Add</span><span class="eth-btn-spinner"></span>';
      wrapper.appendChild(btn);
    } else {
      var stepper = document.createElement("div");
      stepper.className = "eth-stepper";
      stepper.setAttribute("data-variant-id", variantId);
      stepper.setAttribute("data-qty", String(qty));
      stepper.innerHTML =
        '<button type="button" class="eth-stepper-btn eth-stepper-minus" aria-label="Remove one">\u2212</button>' +
        '<span class="eth-stepper-qty">' + qty + '</span>' +
        '<button type="button" class="eth-stepper-btn eth-stepper-plus" aria-label="Add one">+</button>';
      wrapper.appendChild(stepper);
    }
  }

  function updateAllSteppersForVariant(variantId, qty) {
    document.querySelectorAll(".eth-cart-control[data-variant-id='" + variantId + "']").forEach(function (wrapper) {
      renderStepper(wrapper, variantId, qty);
    });
  }

  function refreshAllSteppers() {
    document.querySelectorAll(".eth-cart-control[data-variant-id]").forEach(function (wrapper) {
      var vid = wrapper.getAttribute("data-variant-id");
      renderStepper(wrapper, vid, window.ethCartState[vid] || 0);
    });
  }

  function injectStepperWrappers(root) {
    root = root || document;
    root.querySelectorAll(".eth-quick-card-btn.js-grid-cart:not(.eth-cart-control-done)").forEach(function (btn) {
      var vid = String(btn.getAttribute("data-id") || ""); if (!vid) return;
      var ctrl = document.createElement("span"); ctrl.className = "eth-cart-control"; ctrl.setAttribute("data-variant-id", vid);
      btn.parentNode.replaceChild(ctrl, btn); renderStepper(ctrl, vid, window.ethCartState[vid] || 0);
    });
    root.querySelectorAll(".js-grid-cart:not(.eth-quick-card-btn):not([data-eth-qb-add]):not(.eth-cart-control-done)").forEach(function (btn) {
      var vid = String(btn.getAttribute("data-id") || ""); if (!vid) return;
      if (!btn.closest(".js-product-card")) return;
      var ctrl = document.createElement("span"); ctrl.className = "eth-cart-control"; ctrl.setAttribute("data-variant-id", vid);
      btn.parentNode.replaceChild(ctrl, btn); renderStepper(ctrl, vid, window.ethCartState[vid] || 0);
    });
    root.querySelectorAll(".eth-card-atc.js-grid-cart:not(.eth-cart-control-done)").forEach(function (btn) {
      var vid = String(btn.getAttribute("data-id") || ""); if (!vid) return;
      var ctrl = document.createElement("span"); ctrl.className = "eth-cart-control"; ctrl.setAttribute("data-variant-id", vid);
      btn.parentNode.replaceChild(ctrl, btn); renderStepper(ctrl, vid, window.ethCartState[vid] || 0);
    });
  }

  // ── Cart add/change ──────────────────────────────────────────
  function cartAdd(variantId, qty, callback) {
    var fd = new FormData(); fd.append("id", variantId); fd.append("quantity", qty);
    fetch(rootUrl + "cart/add.js", {
      method: "POST", credentials: "same-origin", body: fd,
      headers: { "Accept": "application/json" }
    })
      .then(function (r) { return r.ok ? r.json() : r.json().then(function (e) { throw e; }); })
      .then(function (item) { if (callback) callback(null, item); })
      .catch(function (e) { if (callback) callback(e, null); });
  }

  function cartChange(variantId, qty, callback) {
    fetch(rootUrl + "cart/change.js", {
      method: "POST", credentials: "same-origin",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ id: variantId, quantity: qty })
    })
      .then(function (r) { return r.ok ? r.json() : r.json().then(function (e) { throw e; }); })
      .then(function (cart) { if (callback) callback(null, cart); })
      .catch(function (e) { if (callback) callback(e, null); });
  }

  function handleAdd(variantId, wrapper, onDone) {
    if (!variantId) return;
    var vid = String(variantId);
    if (!lockVariant(vid)) return;
    if (wrapper) { var addBtn = wrapper.querySelector(".eth-add-btn"); if (addBtn) addBtn.classList.add("is-loading"); }
    cartAdd(vid, 1, function (err) {
      if (err) {
        unlockVariant(vid);
        if (wrapper) { var b = wrapper.querySelector(".eth-add-btn"); if (b) b.classList.remove("is-loading"); }
        showToast("Couldn\u2019t add \u2014 please try again");
        return;
      }
      fetchCart(function (cart) {
        unlockVariant(vid);
        updateAllSteppersForVariant(vid, window.ethCartState[vid] || 1);
        showToast("\u2713 Added to bag");
        injectStepperWrappers(document);
        if (onDone) onDone(cart, window.ethCartState[vid] || 1);
      });
    });
  }

  function handleDecrement(variantId) {
    var vid = String(variantId);
    var currentQty = window.ethCartState[vid] || 0;
    if (currentQty <= 0) return;
    if (!lockVariant(vid)) return;
    var newQty = currentQty - 1;
    window.ethCartState[vid] = newQty;
    updateAllSteppersForVariant(vid, newQty);
    cartChange(vid, newQty, function (err) {
      if (err) { unlockVariant(vid); window.ethCartState[vid] = currentQty; updateAllSteppersForVariant(vid, currentQty); return; }
      fetchCart(function () { unlockVariant(vid); updateAllSteppersForVariant(vid, window.ethCartState[vid] || 0); });
    });
  }

  function handleIncrement(variantId) {
    var vid = String(variantId);
    var currentQty = window.ethCartState[vid] || 0;
    if (!lockVariant(vid)) return;
    var newQty = currentQty + 1;
    window.ethCartState[vid] = newQty;
    updateAllSteppersForVariant(vid, newQty);
    document.querySelectorAll(".eth-cart-control[data-variant-id='" + vid + "'] .eth-stepper-qty").forEach(function (el) {
      el.classList.remove("eth-bump"); void el.offsetWidth; el.classList.add("eth-bump");
    });
    cartAdd(vid, 1, function (err) {
      if (err) {
        unlockVariant(vid);
        window.ethCartState[vid] = currentQty;
        updateAllSteppersForVariant(vid, currentQty);
        showToast("Couldn\u2019t update \u2014 please try again");
        return;
      }
      fetchCart(function () { unlockVariant(vid); updateAllSteppersForVariant(vid, window.ethCartState[vid] || 0); });
    });
  }

  // ── Grid click delegation ────────────────────────────────────
  document.addEventListener("click", function (e) {
    var minusBtn = e.target.closest(".eth-stepper-btn.eth-stepper-minus");
    if (minusBtn) {
      e.preventDefault(); e.stopPropagation();
      var stepper = minusBtn.closest(".eth-stepper");
      var vid = stepper ? stepper.getAttribute("data-variant-id") : null;
      if (vid) handleDecrement(vid);
      return;
    }
    var plusBtn = e.target.closest(".eth-stepper-btn.eth-stepper-plus");
    if (plusBtn) {
      e.preventDefault(); e.stopPropagation();
      var stepper2 = plusBtn.closest(".eth-stepper");
      var vid2 = stepper2 ? stepper2.getAttribute("data-variant-id") : null;
      if (vid2) handleIncrement(vid2);
      return;
    }
    var addBtn = e.target.closest(".eth-add-btn");
    if (addBtn && !addBtn.classList.contains("is-loading") && !addBtn.disabled) {
      e.preventDefault(); e.stopPropagation();
      var vid3 = addBtn.getAttribute("data-variant-id");
      if (vid3) handleAdd(vid3, addBtn.closest(".eth-cart-control"), null);
      return;
    }
    var gridCartBtn = e.target.closest(".js-grid-cart");
    if (gridCartBtn && !gridCartBtn.classList.contains("disabled")) {
      e.preventDefault(); e.stopPropagation();
      var vid4 = String(gridCartBtn.getAttribute("data-id") || "");
      if (!vid4) return;
      var wrapper4 = gridCartBtn.closest(".eth-cart-control");
      if (!wrapper4) {
        var ctrl4 = document.createElement("span");
        ctrl4.className = "eth-cart-control";
        ctrl4.setAttribute("data-variant-id", vid4);
        gridCartBtn.parentNode.replaceChild(ctrl4, gridCartBtn);
        wrapper4 = ctrl4;
      }
      handleAdd(vid4, wrapper4, null);
      return;
    }
  }, true);

  // ── Modal state ──────────────────────────────────────────────
  var activeSectionId = null;
  var activeQuickIndex = 0;
  var activeImageIndex = 0;
  var activeImages = [];
  var activeOptions = [];
  var activeVariants = [];
  var selectedOptions = [];
  var activeProductUrl = "";
  var descriptionCache = {};
  var descriptionPromises = {};
  var cartAddInFlight = false;
  var cartAddInflightTimer = null;
  var qbLastTrigger = null; // element that opened the modal, for focus restore

  function setCartInflight(state) {
    cartAddInFlight = state;
    clearTimeout(cartAddInflightTimer);
    if (state) {
      cartAddInflightTimer = setTimeout(function () { cartAddInFlight = false; }, 6000);
    }
  }

  // ── Modal DOM refs ───────────────────────────────────────────
  function qb(selector) { return document.querySelector(selector); }

  // Focusable elements currently inside the open modal (for the focus trap).
  function getQbFocusable() {
    if (!qbModal) return [];
    return Array.prototype.slice.call(qbModal.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )).filter(function (el) { return el.offsetParent !== null; });
  }

  var qbModal      = null;
  var qbCard       = null;
  var qbImage      = null;
  var qbImageZone  = null;
  var qbImageLink  = null;
  var qbTitleLink  = null;
  var qbTitle      = null;
  var qbPrice      = null;
  var qbCompare    = null;
  var qbShort      = null;
  var qbMore       = null;
  var qbFullDesc   = null;
  var qbScroll     = null;
  var qbOptions    = null;
  var qbAdd        = null;
  var qbPrev       = null;
var qbNext       = null;
var qbImgPrev    = null;
var qbImgNext    = null;
  var qbScrollHint = null;

  function bindModalRefs() {
    qbModal     = qb("[data-eth-qb-modal]");
    qbCard      = qb("[data-eth-qb-card]");
    qbImage     = qb("[data-eth-qb-image]");
    qbImageZone = qb("[data-eth-qb-image-zone]");
    qbImageLink = qb("[data-eth-qb-image-link]");
    qbTitleLink = qb("[data-eth-qb-title-link]");
    qbTitle     = qb("[data-eth-qb-title]");
    qbPrice     = qb("[data-eth-qb-price]");
    qbCompare   = qb("[data-eth-qb-compare]");
    qbShort     = qb("[data-eth-qb-short]");
    qbMore      = qb("[data-eth-qb-more]");
    qbFullDesc  = qb("[data-eth-qb-full-desc]");
    qbScroll    = qb("[data-eth-qb-scroll]");
    qbOptions   = qb("[data-eth-qb-options]");
    qbAdd       = qb("[data-eth-qb-add]");
    qbPrev      = qb("[data-eth-qb-prev]");
qbNext      = qb("[data-eth-qb-next]");
qbImgPrev   = qb("[data-eth-qb-img-prev]");
qbImgNext   = qb("[data-eth-qb-img-next]");
  }

  // ── Section-scoped product list ──────────────────────────────
  function getQuickBuyItems() {
    if (!activeSectionId) return [];
    return Array.prototype.slice.call(
      document.querySelectorAll(".eth-open-quick-buy[data-section-id='" + activeSectionId + "']")
    );
  }

  // ── Money formatter ──────────────────────────────────────────
  function money(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === "function") {
      return Shopify.formatMoney(cents, window.ethMoneyFormat || "Rs. {{amount}}");
    }
    var amount = Number(cents || 0) / 100;
    return "Rs. " + amount.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function parseJSON(value, fallback) {
    try { return JSON.parse(value || ""); } catch (e) { return fallback; }
  }

  // ── Image preload ────────────────────────────────────────────
  function preloadImage(src) {
  return new Promise(function (resolve) {
    if (!src) { resolve(); return; }
    if (src.indexOf('//') === 0) src = 'https:' + src;
      var img = new Image();
      img.onload = function () { resolve(img); };
      img.onerror = function () { resolve(null); };
      img.src = src;
      setTimeout(resolve, 200);
    });
  }

  function updateImage(src, alt, skipFade) {
    if (!qbImage || !src) return;
    if (skipFade) {
      qbImage.style.transition = "none";
      qbImage.style.opacity = "1";
      qbImage.style.transform = "scale(1) translateX(0)";
      qbImage.src = src; qbImage.alt = alt || "";
      return;
    }
    qbImage.style.transition = "opacity 120ms ease";
    qbImage.style.opacity = "0";
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        qbImage.src = src; qbImage.alt = alt || "";
        qbImage.style.transition = "opacity 160ms ease";
        qbImage.style.opacity = "1";
        qbImage.style.transform = "scale(1) translateX(0)";
      });
    });
  }

 function setImageByIndex(index, direction) {
  if (!activeImages.length) return;
  if (index < 0) index = activeImages.length - 1;
  if (index >= activeImages.length) index = 0;

  var targetImg = activeImages[index];
  var targetSrc = typeof targetImg === 'string' ? targetImg : targetImg.src;
  var targetAlt = (typeof targetImg === 'object' && targetImg.alt) ? targetImg.alt : (qbTitle ? qbTitle.textContent : "") || "";
  if (targetSrc && targetSrc.indexOf('//') === 0) targetSrc = 'https:' + targetSrc;

  if (!targetSrc) return;

  // Hide immediately before loading new image
  if (qbImage) {
    qbImage.style.transition = "none";
    qbImage.style.opacity = "0";
  }

  var _img = qbImage;
  var newImg = new Image();

  newImg.onload = function() {
    if (_img) {
      _img.src = targetSrc;
      _img.alt = targetAlt;
      activeImageIndex = index;
      requestAnimationFrame(function() {
        _img.style.transition = "opacity 180ms ease";
        _img.style.opacity = "1";
      });
      updateImageDots(qbImageZone, activeImageIndex, activeImages.length);
    }
  };

  newImg.onerror = function() {
    // Load anyway even if preload failed
    if (_img) {
      _img.src = targetSrc;
      _img.alt = targetAlt;
      activeImageIndex = index;
      _img.style.transition = "opacity 180ms ease";
      _img.style.opacity = "1";
      updateImageDots(qbImageZone, activeImageIndex, activeImages.length);
    }
  };

  newImg.src = targetSrc;
}

  // ── Modal stepper ────────────────────────────────────────────
  function syncModalStepper(variantId, qty) {
    if (!qbAdd) return;
    var stepperEl = qb("[data-eth-qb-stepper]");
    var qtyEl = qb("[data-eth-qb-qty]");
    var cartActions = qb("[data-eth-qb-cart-actions]");
    if (qty > 0) {
      qbAdd.style.opacity = "0"; qbAdd.style.pointerEvents = "none";
      if (stepperEl) {
        stepperEl.style.display = "flex"; stepperEl.style.opacity = "1";
        stepperEl.setAttribute("data-variant-id", variantId);
        stepperEl.setAttribute("data-qty", String(qty));
        if (qtyEl) qtyEl.textContent = qty;
      }
      if (cartActions) cartActions.classList.add("is-visible");
    } else {
      if (stepperEl) stepperEl.style.display = "none";
      qbAdd.style.opacity = "1"; qbAdd.style.pointerEvents = "";
      if (cartActions) cartActions.classList.remove("is-visible");
    }
  }

  // ── Close modal ──────────────────────────────────────────────
  function teleportNavArrows(toBody) {
  if (window.innerWidth >= 750) return;
  var prev = qb("[data-eth-qb-prev]");
  var next = qb("[data-eth-qb-next]");
  if (!prev || !next) return;
  if (toBody) {
    document.body.appendChild(prev);
    document.body.appendChild(next);
  } else {
    if (qbModal) {
      qbModal.insertBefore(next, qbModal.firstChild);
      qbModal.insertBefore(prev, qbModal.firstChild);
    }
  }
}

function closeQuickBuy() {
  syncModalStepper("", 0);
  teleportNavArrows(false);
  document.body.classList.remove("eth-qb-open");
  document.documentElement.classList.remove("overflow-hidden");
  document.body.classList.remove("overflow-hidden");
  if (qbModal) qbModal.setAttribute("aria-hidden", "true");
  if (qbLastTrigger && typeof qbLastTrigger.focus === "function") {
    try { qbLastTrigger.focus({ preventScroll: true }); } catch (e) { qbLastTrigger.focus(); }
  }
  qbLastTrigger = null;
}
  // ── Variant helpers ──────────────────────────────────────────
  function getVariantOptions(variant) {
    if (Array.isArray(variant.options) && variant.options.length) return variant.options;
    var opts = [];
    if (variant.option1 != null) opts.push(variant.option1);
    if (variant.option2 != null) opts.push(variant.option2);
    if (variant.option3 != null) opts.push(variant.option3);
    return opts;
  }

  function findSelectedVariant() {
    if (!activeOptions.length) return null;
    for (var i = 0; i < activeOptions.length; i++) { if (!selectedOptions[i]) return null; }
    return activeVariants.find(function (variant) {
      var opts = getVariantOptions(variant);
      return activeOptions.every(function (option, index) { return opts[index] === selectedOptions[index]; });
    }) || null;
  }

  function isOptionValueAvailable(optionIndex, value) {
    return activeVariants.some(function (variant) {
      if (!variant.available) return false;
      var opts = getVariantOptions(variant);
      if (opts[optionIndex] !== value) return false;
      for (var i = 0; i < activeOptions.length; i++) {
        if (i === optionIndex) continue;
        if (selectedOptions[i] && opts[i] !== selectedOptions[i]) return false;
      }
      return true;
    });
  }

  function updateQuickBuyState() {
    var selectedVariant = findSelectedVariant();
    if (!qbAdd) return;
    qbAdd.setAttribute("data-id", "");
    qbAdd.classList.add("is-disabled");
    if (selectedVariant) {
      qbPrice.textContent = money(selectedVariant.price);
      qbCompare.textContent = (selectedVariant.compare_at_price && selectedVariant.compare_at_price > selectedVariant.price)
        ? money(selectedVariant.compare_at_price) : "";
      if (selectedVariant.featured_image && selectedVariant.featured_image.src) {
        updateImage(selectedVariant.featured_image.src, qbTitle.textContent || "");
      }
      if (selectedVariant.available) {
        qbAdd.setAttribute("data-id", selectedVariant.id);
        qbAdd.classList.remove("is-disabled");
      }
      var modalVid = String(selectedVariant.id);
      var modalQty = (window.ethCartState && window.ethCartState[modalVid]) || 0;
      syncModalStepper(modalVid, modalQty);
    } else {
      syncModalStepper("", 0);
    }
    renderOptionButtons();
  }

  function renderOptionButtons() {
    if (!qbOptions) return;
    qbOptions.innerHTML = "";
    activeOptions.forEach(function (option, optionIndex) {
      var group = document.createElement("div");
      group.className = "eth-qb-option-group";
      var label = document.createElement("p");
      label.className = "eth-qb-option-label";
      label.textContent = option.name || ("Option " + (optionIndex + 1));
      var valuesWrap = document.createElement("div");
      valuesWrap.className = "eth-qb-option-values";
      (option.values || []).forEach(function (value) {
        var button = document.createElement("button");
        button.type = "button"; button.className = "eth-qb-option-btn";
        button.textContent = value;
        if (selectedOptions[optionIndex] === value) button.classList.add("is-active");
        if (!isOptionValueAvailable(optionIndex, value)) { button.classList.add("is-disabled"); button.disabled = true; }
        button.addEventListener("click", function () {
          selectedOptions[optionIndex] = value;
          for (var i = optionIndex + 1; i < selectedOptions.length; i++) {
            var stillValid = activeVariants.some(function (v) {
              if (!v.available) return false;
              var opts = getVariantOptions(v);
              for (var j = 0; j <= i; j++) {
                if (selectedOptions[j] != null && selectedOptions[j] !== "" && opts[j] !== selectedOptions[j]) return false;
              }
              return true;
            });
            if (!stillValid) selectedOptions[i] = "";
          }
          updateQuickBuyState();
        });
        valuesWrap.appendChild(button);
      });
      group.appendChild(label);
      group.appendChild(valuesWrap);
      qbOptions.appendChild(group);
    });
  }

  // ── Description fetch ────────────────────────────────────────
  function productJsonUrl(url) {
    if (!url || url === "#") return "";
    var clean = url.split("?")[0].replace(/\/$/, "");
    if (clean.slice(-3) === ".js") return clean;
    return clean + ".js";
  }

  function normalizeText(value) {
    return String(value || "").replace(/<[^>]*>/g, " ").replace(/&nbsp;/g, " ").replace(/\s+/g, " ").trim().toLowerCase();
  }

  function cleanProductDescription(html, shortText) {
    var wrap = document.createElement("div");
    wrap.innerHTML = html || "";
    wrap.querySelectorAll("script, style, iframe, form, button, input, select, textarea").forEach(function (el) { el.remove(); });
    var shortNorm = normalizeText(shortText);
    var first = wrap.querySelector("p, div, span");
    if (first && shortNorm && shortNorm.length >= 30) {
      var firstNorm = normalizeText(first.textContent || "");
      var shorter = Math.min(firstNorm.length, shortNorm.length);
      var longer = Math.max(firstNorm.length, shortNorm.length);
      if (shorter > 0 && shorter / longer > 0.8) first.remove();
    }
    return wrap.innerHTML.trim() || html || shortText || "";
  }

  function fetchFullDescription(url, shortText) {
    if (!url || url === "#") return Promise.resolve("");
    if (descriptionCache[url]) return Promise.resolve(descriptionCache[url]);
    if (descriptionPromises[url]) return descriptionPromises[url];
    var jsonUrl = productJsonUrl(url);
    if (!jsonUrl) return Promise.resolve("");
    descriptionPromises[url] = fetch(jsonUrl, { credentials: "same-origin" })
      .then(function (res) { return res.ok ? res.json() : Promise.reject(res); })
      .then(function (product) {
        var html = product.description || product.body_html || "";
        if (!html) throw new Error("No description");
        html = cleanProductDescription(html, shortText || "");
        descriptionCache[url] = html;
        delete descriptionPromises[url];
        return html;
      })
      .catch(function (error) { delete descriptionPromises[url]; throw error; });
    return descriptionPromises[url];
  }

  function prefetchFullDescription(url, shortText) {
    if (!url || descriptionCache[url] || descriptionPromises[url]) return;
    window.setTimeout(function () { fetchFullDescription(url, shortText).catch(function () {}); }, 60);
  }

  function resetFullDescription(shortText) {
    if (qbShort) { qbShort.textContent = shortText || ""; qbShort.hidden = false; }
    if (qbFullDesc) { qbFullDesc.innerHTML = ""; qbFullDesc.hidden = true; }
    if (qbMore) { qbMore.hidden = !activeProductUrl; qbMore.disabled = false; qbMore.textContent = "More"; }
  }

  function loadFullDescription() {
    if (!activeProductUrl || !qbMore || !qbShort) return;
    var currentUrl = activeProductUrl;
    var currentShort = qbShort ? qbShort.textContent : "";
    if (descriptionCache[currentUrl]) {
      qbShort.innerHTML = descriptionCache[currentUrl];
      qbShort.hidden = false;
      if (qbFullDesc) qbFullDesc.hidden = true;
      qbMore.hidden = true;
      return;
    }
    qbMore.disabled = true; qbMore.textContent = "More";
    fetchFullDescription(currentUrl, currentShort)
      .then(function (html) {
        if (currentUrl !== activeProductUrl) return;
        qbShort.innerHTML = html; qbShort.hidden = false;
        if (qbFullDesc) qbFullDesc.hidden = true;
        qbMore.hidden = true;
      })
      .catch(function () {
        if (currentUrl !== activeProductUrl) return;
        qbMore.disabled = false; qbMore.textContent = "View full details";
      });
  }

  // ── Scroll hint ──────────────────────────────────────────────
  function ensureQuickBuyScrollHint() {
    if (!qbModal || qbScrollHint) return;
    qbScrollHint = document.createElement("div");
    qbScrollHint.className = "eth-qb-scroll-hint";
    qbScrollHint.innerHTML = "<span>Scroll for details</span>" +
      "<svg viewBox='0 0 24 24' fill='none' aria-hidden='true'>" +
      "<path d='M7 10l5 5 5-5' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'></path>" +
      "</svg>";
    qbModal.appendChild(qbScrollHint);
  }

  function refreshQuickBuyScrollHint() {
    if (!qbModal || window.innerWidth >= 750) return;
    ensureQuickBuyScrollHint();
    qbModal.classList.remove("eth-qb-has-scrolled");
    requestAnimationFrame(function () {
      var canScroll = qbModal.scrollHeight > qbModal.clientHeight + 18;
      qbModal.classList.toggle("eth-qb-can-scroll", canScroll);
    });
  }

  function markQuickBuyScrolled() {
    if (!qbModal || window.innerWidth >= 750) return;
    if (qbModal.scrollTop > 12) qbModal.classList.add("eth-qb-has-scrolled");
  }

  // ── Apply product to modal ───────────────────────────────────
  function applyProductToModal(data) {
  // Hide content and image immediately before applying new data
  // so old product never flashes before new one appears
  var contentEl = qb("[data-eth-qb-content-zone]");
  if (contentEl) { contentEl.style.opacity = "0"; }
  if (qbImage) { qbImage.style.transition = "none"; qbImage.style.opacity = "0"; }
  syncModalStepper("", 0);

  qbTitle.textContent = data.title;
  qbPrice.textContent = data.price ? money(data.price) : "";
  qbCompare.textContent = data.compare ? money(data.compare) : "";
  activeProductUrl = data.url || "";
  resetFullDescription(data.shortText);
  if (qbTitleLink) { qbTitleLink.href = activeProductUrl || "#"; }
  if (qbImageLink) { qbImageLink.href = activeProductUrl || "#"; }
  if (qbScroll) qbScroll.scrollTop = 0;
  if (qbModal) qbModal.scrollTop = 0;
  qbAdd.setAttribute("data-id", "");
  qbAdd.classList.add("is-disabled");
  activeOptions = data.options;
  activeVariants = data.variants;
  activeImages = data.images.map(function(img) {
    if (typeof img === 'string') return { src: img, alt: data.title || '' };
    return img;
  });
  selectedOptions = activeOptions.map(function(option) {
    var values = option.values || [];
    return values.length === 1 ? values[0] : "";
  });
  var firstSrc = data.firstImageSrc;
  if (firstSrc && firstSrc.indexOf('//') === 0) firstSrc = 'https:' + firstSrc;
  if (qbImage && firstSrc) {
  qbImage.style.transition = "none";
  qbImage.style.opacity = "0";
  qbImage.src = firstSrc;
  qbImage.alt = data.firstImageAlt || data.title;
  var _img = qbImage;
  _img.onload = function() {
    _img.style.transition = "opacity 220ms ease";
    _img.style.opacity = "1";
    _img.onload = null;
  };
  // Fallback for cached images where onload never fires
  requestAnimationFrame(function() {
    requestAnimationFrame(function() {
      if (_img.complete && _img.naturalWidth > 0 && _img.style.opacity === "0") {
        _img.style.transition = "opacity 220ms ease";
        _img.style.opacity = "1";
      }
    });
  });
}
  activeImageIndex = 0;
  injectImageDots(qbImageZone, activeImages.length);
  renderOptionButtons();
  updateQuickBuyState();
}
  // ── Open modal ───────────────────────────────────────────────
  function openQuickBuyByIndex(index) {
    var items = getQuickBuyItems();
    var button = items[index];
    if (!button || !qbModal) return;

    var title    = button.getAttribute("data-product-title") || "";
    var price    = button.getAttribute("data-product-price") || "";
    var compare  = button.getAttribute("data-product-compare-price") || "";
    var image    = button.getAttribute("data-product-image") || "";
    var url      = button.getAttribute("data-product-url") || "#";
    var shortText = button.getAttribute("data-product-short") || "";
    var options  = parseJSON(button.getAttribute("data-product-options"), []);
    var variants = parseJSON(button.getAttribute("data-product-variants"), []);
    var images   = parseJSON(button.getAttribute("data-product-images"), []);
    // Normalise images array — entries may be plain strings or {src, alt} objects
images = images.map(function(img) {
  if (typeof img === 'string') return { src: img, alt: title };
  return img;
});
if (!images.length && image) images = [{ src: image, alt: title }];
var firstSrc = images.length ? images[0].src : image;
if (firstSrc && firstSrc.indexOf('//') === 0) firstSrc = 'https:' + firstSrc;
var firstAlt = images.length ? (images[0].alt || title) : title;

    var isFirstOpen = !document.body.classList.contains("eth-qb-open");
    activeQuickIndex = index;

    if (isFirstOpen) {
  document.body.classList.add("eth-qb-open");
  qbModal.setAttribute("aria-hidden", "false");
  document.documentElement.classList.add("overflow-hidden");
  document.body.classList.add("overflow-hidden");
  teleportNavArrows(true);
}

var contentEl = qb("[data-eth-qb-content-zone]");
if (!isFirstOpen && contentEl) {
  contentEl.style.transition = "opacity 80ms ease";
  contentEl.style.opacity = "0";
  if (qbImage) { qbImage.style.transition = "opacity 80ms ease"; qbImage.style.opacity = "0"; }
}

    preloadImage(firstSrc).then(function () {
  if (activeQuickIndex !== index) return; // a newer navigation superseded this one
  var data = {
    title: title, price: price, compare: compare,
    shortText: shortText, url: url,
    options: options, variants: variants, images: images,
    firstImageSrc: firstSrc, firstImageAlt: firstAlt
  };
  applyProductToModal(data);
  if (isFirstOpen) {
    var qbCloseBtn = qb("[data-eth-qb-close]");
    if (qbCloseBtn) { try { qbCloseBtn.focus({ preventScroll: true }); } catch (e) { qbCloseBtn.focus(); } }
  }
  prefetchFullDescription(url, shortText);
  setTimeout(refreshQuickBuyScrollHint, 80);
  setTimeout(function() {
  if (contentEl) { contentEl.style.transition = "none"; contentEl.style.opacity = "1"; }
    if (!document.body.classList.contains("eth-qb-open")) {
  document.body.classList.add("eth-qb-open");
  qbModal.setAttribute("aria-hidden", "false");
  document.documentElement.classList.add("overflow-hidden");
  document.body.classList.add("overflow-hidden");
  teleportNavArrows(true);
}
  }, 60);
});
  }

  // ── Modal click delegation (bubble phase) ────────────────────
  // Consolidated: open trigger, close, read-more, prev, next, add-to-cart.
  document.addEventListener("click", function (event) {
    // Open trigger
    var trigger = event.target.closest(".eth-open-quick-buy");
    if (trigger) {
      event.preventDefault(); event.stopPropagation();
      qbLastTrigger = trigger;
      activeSectionId = trigger.getAttribute("data-section-id");
      var openItems = Array.prototype.slice.call(
        document.querySelectorAll(".eth-open-quick-buy[data-section-id='" + activeSectionId + "']")
      );
      var openIndex = openItems.indexOf(trigger);
      if (openIndex >= 0) openQuickBuyByIndex(openIndex);
      return;
    }

    // Close
    if (event.target.closest("[data-eth-qb-close]")) { closeQuickBuy(); return; }

    // Read more
    if (event.target.closest("[data-eth-qb-more]")) {
      event.preventDefault(); event.stopPropagation();
      loadFullDescription();
      return;
    }

    // Prev
    if (event.target.closest("[data-eth-qb-prev]")) {
      event.preventDefault(); event.stopPropagation();
      var prevItems = getQuickBuyItems();
      if (prevItems.length) openQuickBuyByIndex(activeQuickIndex <= 0 ? prevItems.length - 1 : activeQuickIndex - 1);
      return;
    }

    // Next
    if (event.target.closest("[data-eth-qb-next]")) {
      event.preventDefault(); event.stopPropagation();
      var nextItems = getQuickBuyItems();
      if (nextItems.length) openQuickBuyByIndex(activeQuickIndex >= nextItems.length - 1 ? 0 : activeQuickIndex + 1);
      return;
    }

    // Add to cart (modal)
    var addButton = event.target.closest("[data-eth-qb-add]");
    if (addButton) {
      event.preventDefault(); event.stopPropagation();
      var variantId = addButton.getAttribute("data-id");
      if (!variantId || addButton.classList.contains("is-disabled") || addButton.classList.contains("is-loading")) return;
      if (cartAddInFlight) return;
      setCartInflight(true);

      window.ethCartState = window.ethCartState || {};
      var optimisticQty = ((window.ethCartState[String(variantId)]) || 0) + 1;
      window.ethCartState[String(variantId)] = optimisticQty;
      syncModalStepper(String(variantId), optimisticQty);
      updateAllSteppersForVariant(String(variantId), optimisticQty);

      var firstBadge = document.querySelector(".js-cart-count, [data-cart-count], .cart-count-bubble, #CartCount");
      var optimisticTotal = (parseInt((firstBadge && firstBadge.textContent) || "0", 10) || 0) + 1;
      updateAllCartBadges(optimisticTotal);
      showToast("\u2713 Added to bag");

      var formData = new FormData();
      formData.append("id", variantId);
      formData.append("quantity", "1");

      fetch(rootUrl + "cart/add.js", {
        method: "POST", body: formData, credentials: "same-origin",
        headers: { "Accept": "application/json" }
      })
        .then(function (r) { if (!r.ok) return r.json().then(function (e) { throw e; }); return r.json(); })
        .then(function () { return fetch(rootUrl + "cart.js", { method: "GET", credentials: "same-origin", headers: { "Accept": "application/json" } }); })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var state = {};
          (cart.items || []).forEach(function (item) {
            state[String(item.variant_id)] = (state[String(item.variant_id)] || 0) + item.quantity;
          });
          window.ethCartState = state;
          syncModalStepper(String(variantId), window.ethCartState[String(variantId)] || 0);
          refreshAllSteppers();
          updateAllCartBadges(cart.item_count);
          document.dispatchEvent(new CustomEvent("cart:updated", { detail: { cart: cart } }));
        })
        .catch(function () {
          var revertQty = Math.max(0, optimisticQty - 1);
          window.ethCartState[String(variantId)] = revertQty;
          syncModalStepper(String(variantId), revertQty);
          updateAllSteppersForVariant(String(variantId), revertQty);
          updateAllCartBadges(Math.max(0, optimisticTotal - 1));
          showToast("Couldn\u2019t add \u2014 try again");
        })
        .finally(function () { setCartInflight(false); });
      return;
    }
  });

  // ── Modal stepper delegation (capture phase) ─────────────────
  // Consolidated minus + plus. Capture + stopImmediatePropagation so a
  // stepper tap never also reaches the bubble handlers (e.g. add-to-cart).
  document.addEventListener("click", function (event) {
    // Minus
    if (event.target.closest("[data-eth-qb-minus]")) {
      event.preventDefault(); event.stopImmediatePropagation();
      var stepperElM = qb("[data-eth-qb-stepper]");
      var vidM = stepperElM ? stepperElM.getAttribute("data-variant-id") : null;
      if (!vidM) return;
      var curM = (window.ethCartState && window.ethCartState[vidM]) || 0;
      if (curM <= 0) return;
      if (!lockVariant(vidM)) return;
      var newM = curM - 1;
      window.ethCartState[vidM] = newM;
      syncModalStepper(vidM, newM);
      var qtyElM = qb("[data-eth-qb-qty]");
      if (qtyElM) { qtyElM.classList.remove("eth-bump"); void qtyElM.offsetWidth; qtyElM.classList.add("eth-bump"); }
      updateAllSteppersForVariant(vidM, newM);
      cartChange(vidM, newM, function (err) {
        if (err) { unlockVariant(vidM); window.ethCartState[vidM] = curM; syncModalStepper(vidM, curM); updateAllSteppersForVariant(vidM, curM); return; }
        fetchCart(function () { unlockVariant(vidM); syncModalStepper(vidM, window.ethCartState[vidM] || 0); refreshAllSteppers(); });
      });
      return;
    }

    // Plus
    if (event.target.closest("[data-eth-qb-plus]")) {
      event.preventDefault(); event.stopImmediatePropagation();
      var stepperElP = qb("[data-eth-qb-stepper]");
      var vidP = stepperElP ? stepperElP.getAttribute("data-variant-id") : null;
      if (!vidP) return;
      var curP = (window.ethCartState && window.ethCartState[vidP]) || 0;
      if (!lockVariant(vidP)) return;
      var newP = curP + 1;
      window.ethCartState[vidP] = newP;
      syncModalStepper(vidP, newP);
      var qtyElP = qb("[data-eth-qb-qty]");
      if (qtyElP) { qtyElP.classList.remove("eth-bump"); void qtyElP.offsetWidth; qtyElP.classList.add("eth-bump"); }
      updateAllSteppersForVariant(vidP, newP);
      var fdP = new FormData(); fdP.append("id", vidP); fdP.append("quantity", "1");
      fetch(rootUrl + "cart/add.js", {
        method: "POST", credentials: "same-origin", body: fdP,
        headers: { "Accept": "application/json" }
      })
        .then(function (r) { if (!r.ok) return r.json().then(function (e) { throw e; }); return r.json(); })
        .then(function () {
          fetchCart(function () { unlockVariant(vidP); syncModalStepper(vidP, window.ethCartState[vidP] || 0); refreshAllSteppers(); });
        })
        .catch(function () {
          unlockVariant(vidP);
          window.ethCartState[vidP] = curP;
          syncModalStepper(vidP, curP);
          updateAllSteppersForVariant(vidP, curP);
          showToast("Couldn\u2019t add \u2014 try again");
        });
      return;
    }
  }, true);

  // ── Modal ATC ────────────────────────────────────────────────
  // Add-to-cart is now handled in the consolidated bubble listener above.


  // ── Keyboard ─────────────────────────────────────────────────
  document.addEventListener("keydown", function (event) {
    if (!document.body.classList.contains("eth-qb-open")) return;
    if (event.key === "Escape") { closeQuickBuy(); return; }
    if (event.key === "ArrowLeft" && qbPrev) qbPrev.click();
    if (event.key === "ArrowRight" && qbNext) qbNext.click();
    if (event.key === "Tab") {
      var focusable = getQbFocusable();
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      else if (qbModal && !qbModal.contains(document.activeElement)) { event.preventDefault(); first.focus(); }
    }
  });

  // ── Scroll hint ──────────────────────────────────────────────
  document.addEventListener("scroll", function () {
    if (qbModal) markQuickBuyScrolled();
  }, true);

  window.addEventListener("resize", function () {
    if (qbModal) refreshQuickBuyScrollHint();
  });

  // ── Swipe ────────────────────────────────────────────────────
  function bindSwipe(el, callback) {
    if (!el) return;
    var startX = 0, startY = 0, startTime = 0, didSwipe = false;
    el.addEventListener("touchstart", function (event) {
      if (!event.touches || !event.touches.length) return;
      didSwipe = false;
      startX = event.touches[0].clientX;
      startY = event.touches[0].clientY;
      startTime = Date.now();
    }, { passive: true });
    el.addEventListener("touchend", function (event) {
      if (!event.changedTouches || !event.changedTouches.length) return;
      var endX = event.changedTouches[0].clientX;
      var endY = event.changedTouches[0].clientY;
      var diffX = endX - startX;
      var diffY = endY - startY;
      var duration = Math.max(Date.now() - startTime, 1);
      var velocity = Math.abs(diffX) / duration;
      var isHorizontal = Math.abs(diffX) > Math.abs(diffY) * 1.35;
      var isStrongEnough = Math.abs(diffX) > 48 || velocity > 0.34;
      if (!isHorizontal || !isStrongEnough) return;
      var handled = callback(diffX > 0 ? "right" : "left", event);
      if (handled === false) return;
      didSwipe = true;
      setTimeout(function () { didSwipe = false; }, 180);
    }, { passive: true });
    el.addEventListener("click", function (event) {
      if (!didSwipe) return;
      event.preventDefault(); event.stopPropagation();
    }, true);
  }

  // ── Image dots ───────────────────────────────────────────────
  function injectImageDots(imageZone, total) {
  if (!imageZone) return;
  var existing = imageZone.querySelector(".eth-qb-dots");
  if (existing) existing.remove();
  if (total <= 1) {
    imageZone.setAttribute("data-single-image", "");
    return;
  }
  imageZone.removeAttribute("data-single-image");
    var dotsEl = document.createElement("div"); dotsEl.className = "eth-qb-dots";
    for (var i = 0; i < Math.min(total, 8); i++) {
      var dot = document.createElement("span");
      dot.className = "eth-qb-dot" + (i === 0 ? " is-active" : "");
      dotsEl.appendChild(dot);
    }
    imageZone.appendChild(dotsEl);
  }

  function updateImageDots(imageZone, activeIndex, total) {
    var dotsEl = imageZone ? imageZone.querySelector(".eth-qb-dots") : null;
    if (!dotsEl) return;
    dotsEl.querySelectorAll(".eth-qb-dot").forEach(function (dot, i) {
      dot.classList.toggle("is-active", i === activeIndex);
    });
  }

  // ── Bottom sheet drag ────────────────────────────────────────
  function initBottomSheetDrag(modal) {
    if (!modal) return;
    var startY = 0, currentY = 0, dragging = false;
    modal.addEventListener("touchstart", function (e) {
      if (window.innerWidth >= 750) return;
      var target = e.target;
      if (target && target.closest && target.closest(".eth-qb-footer, .eth-qb-scroll, button, a, input, select, textarea")) {
        dragging = false; return;
      }
      startY = e.touches[0].clientY; currentY = startY; dragging = true;
      modal.style.transition = "none";
    }, { passive: true });
    modal.addEventListener("touchmove", function (e) {
      if (!dragging || window.innerWidth >= 750) return;
      currentY = e.touches[0].clientY;
      var delta = currentY - startY;
      if (delta > 0) modal.style.transform = "translateY(" + delta + "px)";
    }, { passive: true });
    modal.addEventListener("touchend", function () {
      if (!dragging || window.innerWidth >= 750) return;
      dragging = false;
      var delta = currentY - startY;
      modal.style.transition = "";
      if (delta > 80) {
        modal.style.transform = "translateY(100%)";
        setTimeout(function () {
          modal.style.transform = "";
          closeQuickBuy();
        }, 380);
      } else { modal.style.transform = ""; }
    }, { passive: true });
  }

  // ── Mini cart patch ──────────────────────────────────────────
  function patchMiniCart() {
    var miniCartEl = document.querySelector(".js-mini-cart");
    if (!miniCartEl) return;
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.type === "attributes" && m.attributeName === "class") {
          var target = m.target;
          if (target.classList.contains("active") && !target.dataset.ethUserOpened) {
            requestAnimationFrame(function () { if (!target.dataset.ethUserOpened) target.classList.remove("active"); });
          }
        }
      });
    });
    observer.observe(miniCartEl, { attributes: true, attributeFilter: ["class"] });
    document.querySelectorAll(".js-toggle-cart").forEach(function (btn) {
      btn.addEventListener("click", function () {
        miniCartEl.dataset.ethUserOpened = "1";
        setTimeout(function () { delete miniCartEl.dataset.ethUserOpened; }, 800);
      });
    });
  }

  // ── Cart updated event ───────────────────────────────────────
  document.addEventListener("cart:updated", function (e) {
    var cart = e.detail && e.detail.cart;
    if (!cart) return;
    var state = {};
    (cart.items || []).forEach(function (item) {
      state[String(item.variant_id)] = (state[String(item.variant_id)] || 0) + item.quantity;
    });
    window.ethCartState = state;
    refreshAllSteppers();
    updateAllCartBadges(cart.item_count);
  });

  // ── Init ─────────────────────────────────────────────────────
  function init() {
    bindModalRefs();

    fetchCart(function () { injectStepperWrappers(document); refreshAllSteppers(); });
    patchMiniCart();

    if (qbModal) {
      initBottomSheetDrag(qbModal);
      qbModal.addEventListener("scroll", markQuickBuyScrolled, { passive: true });
    }

    if (qbMore) {
      qbMore.addEventListener("click", function (event) {
        event.preventDefault(); event.stopPropagation();
        loadFullDescription();
      });
    }

    if (qbImageZone) {
      bindSwipe(qbImageZone, function (direction, event) {
        if (event) event.stopPropagation();
        if (direction === "left") setImageByIndex(activeImageIndex + 1, "left");
        else setImageByIndex(activeImageIndex - 1, "right");
      });
    }

    if (qbCard) {
      bindSwipe(qbCard, function (direction, event) {
        if (event) event.stopPropagation();
        var items = getQuickBuyItems();
        if (!items.length) return false;
        if (direction === "left") openQuickBuyByIndex(activeQuickIndex >= items.length - 1 ? 0 : activeQuickIndex + 1);
        else openQuickBuyByIndex(activeQuickIndex <= 0 ? items.length - 1 : activeQuickIndex - 1);
        return true;
      });
    }

    if (qbPrev) {
      qbPrev.addEventListener("click", function (event) {
        event.preventDefault(); event.stopPropagation();
        var items = getQuickBuyItems();
        if (!items.length) return;
        openQuickBuyByIndex(activeQuickIndex <= 0 ? items.length - 1 : activeQuickIndex - 1);
      });
    }

    if (qbImgPrev) {
  qbImgPrev.addEventListener("click", function (event) {
    event.preventDefault(); event.stopPropagation();
    setImageByIndex(activeImageIndex - 1, "right");
  });
}

if (qbImgNext) {
  qbImgNext.addEventListener("click", function (event) {
    event.preventDefault(); event.stopPropagation();
    setImageByIndex(activeImageIndex + 1, "left");
  });
}

    // Grid observer
    var productGrid = document.querySelector("#product-grid");
    if (productGrid) {
      if (_gridObserver) { _gridObserver.disconnect(); _gridObserver = null; }
      _gridObserver = new MutationObserver(function () { injectStepperWrappers(productGrid); refreshAllSteppers(); });
      _gridObserver.observe(productGrid, { childList: true });
    }
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();

  document.addEventListener("shopify:section:load", function () {
    bindModalRefs();
    setTimeout(function () { fetchCart(function () { injectStepperWrappers(document); refreshAllSteppers(); }); }, 200);
  });

  // ── Public API ───────────────────────────────────────────────
  window.ethStepper = {
    fetchCart: fetchCart,
    showToast: showToast,
    injectWrappers: injectStepperWrappers,
    refreshAll: refreshAllSteppers,
    updateAllSteppersForVariant: updateAllSteppersForVariant,
    injectDots: injectImageDots,
    updateDots: updateImageDots,
    syncVariant: function (variantId) {
      fetchCart(function () { updateAllSteppersForVariant(String(variantId), window.ethCartState[String(variantId)] || 0); });
    }
  };

})();